import React, { useState } from 'react';
import LoadImage from '@/components/LoadImage';
import TrackingService from '@/services/tracking';
import { UrlObject } from '@/types';
import DetailImg from '@/ui/DetailImg/DetailImg';
import GridListBox from '@/ui/GridListBox';
import { Box } from '@design-system/pc';
import styled from 'styled-components';

interface PreviewProps {
  data?: UrlObject[];
  title: string;
  gtmValue?: Record<string, any>;
}

const Preview = ({ data, title, gtmValue }: PreviewProps) => {
  const [current, setCurrent] = useState<UrlObject | undefined>(undefined);
  return (
    <>
      <GridListBox
        title={title}
        gridNum={2}
        imgList={data}
        isAmount={true}
        disabled={data ? data.length < 3 : false}
        gtmName="shop_preview_image"
        gtmValue={gtmValue}
      >
        {({ item }: any) => (
          <Box
            onClick={() => {
              setCurrent(item);
            }}
            style={{
              cursor: 'pointer',
            }}
            width={375}
            height={211}
            {...TrackingService.tagGTM('shop_preview_image_button', gtmValue)}
          >
            <LoadImage
              src={`https:${item?.url}`}
              alt={`eventRollingBanner`}
              objectFit="cover"
            />
          </Box>
        )}
      </GridListBox>
      {!!current && (
        <DetailBox>
          <DetailImg
            isOpen={!!current}
            onClose={() => {
              setCurrent(undefined);
            }}
            data={data}
            currentData={current}
          />
        </DetailBox>
      )}
    </>
  );
};

export default Preview;

const DetailBox = styled(Box)`
  position: 'fixed';
  width: '100vw';
  height: '100%';
  left: '0px';
  top: '0px';
  z-index: 99999;
`;
